import { Mail, MapPin } from "lucide-react";
import { NAV_LINKS, SERVICES } from "@/data/content";

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="footer"
      className="border-t border-gold/20 bg-black"
    >
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img
              src="/assets/mk-logo.jpg"
              alt="MK Group Plus LLC logo"
              className="h-20 w-20 rounded-full border border-gold/30 object-cover"
            />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-cream/50">
              A premium digital marketing agency helping ambitious businesses
              grow smarter through strategy, creativity, and measurable
              results.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">
              Quick Links
            </h3>
            <ul className="mt-6 space-y-3.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-cream/60 transition-colors duration-300 hover:text-gold"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="/privacy"
                  data-testid="footer-link-privacy"
                  className="text-sm text-cream/60 transition-colors duration-300 hover:text-gold"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms"
                  data-testid="footer-link-terms"
                  className="text-sm text-cream/60 transition-colors duration-300 hover:text-gold"
                >
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">
              Services
            </h3>
            <ul className="mt-6 space-y-3.5">
              {SERVICES.map((s) => (
                <li key={s.title}>
                  <a
                    href="/#services"
                    className="text-sm text-cream/60 transition-colors duration-300 hover:text-gold"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">
              Contact
            </h3>
            <ul className="mt-6 space-y-4">
              <li>
                <a
                  href="mailto:office@mkplus.llc"
                  data-testid="footer-email"
                  className="flex items-center gap-3 text-sm text-cream/60 transition-colors duration-300 hover:text-gold"
                >
                  <Mail className="h-4 w-4 shrink-0 text-gold" />
                  office@mkplus.llc
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-cream/60">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
                <span data-testid="footer-address">
                  Shams Business Center,
                  <br />
                  Sharjah, United Arab Emirates
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="text-xs text-cream/40" data-testid="footer-copyright">
            © {new Date().getFullYear()} MK Group Plus LLC. All Rights Reserved.
          </p>
          <p className="font-serif text-xs italic tracking-[0.2em] text-gold/50">
            Grow Smarter.
          </p>
        </div>
      </div>
    </footer>
  );
}
